import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function usePodcastEpisodes({ podcastId, configs = {}, enabled = false }) {
  const { privateFetch } = useContext(FetchContext); // Extracted here
  const { params = {} } = configs;

  const fetchEpisodes = async () => {
    const response = await privateFetch.get(`/v1/admin/podcast/${podcastId}/episode`, { params });
    return response.data.data;
  };

  return useQuery(['podcast-episodes', podcastId, params], fetchEpisodes, {
    enabled,
    keepPreviousData: true,
  });
}

export default usePodcastEpisodes;
